















































































































import debounce from 'lodash/debounce';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {FamilyGroupManagement} from '@/modules/neovehicle/models/family';
import {Brand, VehicleType, vehicleTypes} from '@/modules/neovehicle/models';
import {FamilyGroupFilter} from '@/modules/neovehicle/models/filters';

@Component
export default class extends Vue {
  @Prop({ type: Array, required: true })
  public data: FamilyGroupManagement[];

  @Prop({ type: Boolean, required: true })
  public loading: boolean;

  @Prop({type: Array})
  public brands: Brand[];

  @Prop({type: Array})
  public vehicleTypesSearch: VehicleType[];

  @Prop({ type: Object, required: true })
  public filter: FamilyGroupFilter;

  public pagination = {
    sortBy: 'name',
    descending: false,
  };

  public vehicleTypes = vehicleTypes;

  public headers = [
    {text: 'Código', value: 'idFamilyGroup', sortable: true, width: 100},
    {text: 'Tipo de Veículo', value: 'idVehicleTypes', width: 150},
    {text: 'Bandeira', value: 'brandName'},
    {text: 'Grupo/Família', value: 'familyGroupName'},
    {text: '', value: '', sortable: false, width: 50},
  ];

  public changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  public get handleSearch() {
    return debounce(() => {
      this.$emit('search');
    }, 1000);
  }

  public handleRemove(familyGroup: FamilyGroupManagement) {
    this.$emit('remove', familyGroup);
  }

  public handleEdit(familyGroup: FamilyGroupManagement) {
    this.$emit('edit', familyGroup);
  }

  public handleCreateGroup() {
    this.$emit('create');
  }
}
